(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/_request/wager.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/_request/wager.js');

'use strict';

class WagerRequest {
  constructor(_ref) {
    let _ref$sequenceNum = _ref.sequenceNum,
      sequenceNum = _ref$sequenceNum === void 0 ? 0 : _ref$sequenceNum,
      voucher = _ref.voucher,
      fractionHolder = _ref.fractionHolder,
      fraction = _ref.fraction,
      _ref$crc = _ref.crc,
      crc = _ref$crc === void 0 ? 0 : _ref$crc,
      subscriptionId = _ref.subscriptionId,
      voucherId = _ref.voucherId,
      marketInfo = _ref.marketInfo,
      _ref$bagType = _ref.bagType,
      bagType = _ref$bagType === void 0 ? 0 : _ref$bagType,
      _ref$bets = _ref.bets,
      bets = _ref$bets === void 0 ? [] : _ref$bets;
    this.request = {};
    if (sequenceNum) {
      this.request.sequenceNum = sequenceNum;
    }
    if (voucher) {
      this.request.voucher = voucher;
    }
    if (fractionHolder) {
      this.request.fractionHolder = fractionHolder;
    }
    if (fraction) {
      this.request.fraction = fraction;
    }
    if (crc) {
      this.request.crc = crc;
    }
    if (subscriptionId) {
      this.request.subscriptionId = subscriptionId;
    }
    if (voucherId) {
      this.request.voucherId = voucherId;
    }
    if (marketInfo) {
      this.request.marketInfo = marketInfo;
    }
    if (bagType) {
      this.request.bagType = bagType;
    }
    if (bets) {
      this.request.bets = bets;
    }
    return this.request;
  }
}
svs.tur.payment.api.jupiter.request.Wager = WagerRequest;

 })(window);